/* ===== SAFETY PATCH: Privacy, Mengenrabatt-Text, Gallery, Accordion ===== */
(() => {
  // ---------- PRIVACY / CHECKOUT-SPERRE ----------
  const privacyRoots = Array.from(document.querySelectorAll('.privacy-cart'));

  const setCheckoutDisabled = (originEl, disabled) => {
    const ctx = originEl?.closest?.('.cart-drawer, .cart') || document;
    const btn = ctx.querySelector('button[name="checkout"]');
    if (btn) btn.disabled = !!disabled;
  };

  const onPrivacyClick = (ev) => {
    const t = ev.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches('.privacy-cart #privacy, .privacy-cart #privacy_drawer')) return;
    setCheckoutDisabled(t, !t.checked);
  };

  if (privacyRoots.length) {
    privacyRoots.forEach((root) => {
      const privacyDrawer = root.querySelector('#privacy_drawer');
      if (privacyDrawer && privacyDrawer.checked) privacyDrawer.checked = false;
      const anyChecked = !!root.querySelector('#privacy:checked, #privacy_drawer:checked');
      setCheckoutDisabled(root, !anyChecked);
    });
    document.addEventListener('click', onPrivacyClick, { passive: true });
  }

  // ---------- MENGENRABATT-TEXT ----------
  setTimeout(() => {
    const specTextElement = document.querySelector('#quantity-discount-app .spec_text');
    if (specTextElement && document.documentElement.lang === 'en') {
      let html = specTextElement.innerHTML;
      html = html.replace('Ab', 'For orders of');
      html = html.replace('Stück erhalten Sie einen Rabatt von', 'or more, you will receive a discount of');
      html = html.replace('off', 'per item');
      specTextElement.innerHTML = html;
    }
  }, 2000);

  // ---------- GALLERY / MEDIA-CAROUSEL ----------
  const initGallery = () => {
    const gallery = document.querySelector('media-carousel');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.product-gallery__media');
    if (!slides.length) return;

    const getCurrentIndex = () =>
      Array.from(slides).findIndex(s => s.classList.contains('is-selected'));

    const hasSelectMethod = typeof gallery.select === 'function';

    const goToIndex = (idx) => {
      if (idx < 0 || idx >= slides.length) return;
      if (hasSelectMethod) {
        try { gallery.select(idx); } catch (e) {}
      } else {
        const cur = getCurrentIndex();
        if (cur >= 0) slides[cur].classList.remove('is-selected');
        slides[idx].classList.add('is-selected');
      }
    };
    // (Optional: hier left/right Arrow-Logik, wenn du willst, via goToIndex)
  }; // <-- WICHTIG: Funktion sauber schließen!

  // Pfeile scrollen Liste (unabhängig von initGallery)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-gallery__arrow');
    if (!btn) return;

    const wrap = btn.closest('.product-gallery');
    const scroller = wrap?.querySelector('.product-gallery__media-list');
    if (!scroller) return;

    const dir = btn.classList.contains('product-gallery__arrow--right') ? 1 : -1;
    const amount = scroller.clientWidth || 600;
    scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
  });

// ---------- ACCORDION ----------
const initAccordion = () => {
  const items = document.querySelectorAll('.accordion-item');
  if (!items.length) return;

  items.forEach((item, index) => {
    const title = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');
    if (!title || !content) return;

    // Erstes Panel beim initialen Laden offen lassen
    if (index === 0 && !item.classList.contains('active')) {
      item.classList.add('active');
      content.style.display = 'block';
    } else if (!item.classList.contains('active')) {
      content.style.display = 'none';
    }

    // doppelte Listener vermeiden
    if (title.dataset.bound === 'true') return;
    title.dataset.bound = 'true';

    title.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Nur das geklickte Panel toggeln — NICHT die anderen schließen
      if (isActive) {
        item.classList.remove('active');
        content.style.display = 'none';
      } else {
        item.classList.add('active');
        content.style.display = 'block';
      }
    }, { passive: true });
  });
};

  // ---------- INITIALISIERUNG ----------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGallery();
      initAccordion();
    });
  } else {
    initGallery();
    initAccordion();
  }

  // bei dynamischem Nachladen erneut
  document.addEventListener('shopify:section:load', () => {
    initGallery();
    initAccordion();
  });
})(); // <-- WICHTIG: IIFE sauber schließen!

// Entfernt leere Judge.me Preview-Badges + deren umgebenden Block
(function () {
  function pruneEmptyJudgeBlocks() {
    document.querySelectorAll('.product-info__block-item[data-block-type="@app"]').forEach(function (block) {
      const widget = block.querySelector('.jdgm-widget.jdgm-preview-badge');
      if (!widget) return;

      const zeroReviews =
        widget.getAttribute('data-number-of-reviews') === '0' ||
        widget.getAttribute('data-average-rating') === '0.00';

      const hiddenByStyle = (widget.style && widget.style.display === 'none');
      const noneTextEl = block.querySelector('.jdgm-prev-badge__text');
      const saysNone = noneTextEl && /Keine Bewertungen/i.test(noneTextEl.textContent || '');

      if (zeroReviews || hiddenByStyle || saysNone) {
        // kompletten Produktblock entfernen, damit KEIN Weißraum bleibt
        block.remove();
      }
    });
  }

  // initial beim Laden
  document.addEventListener('DOMContentLoaded', pruneEmptyJudgeBlocks);

  // bei Variant-Wechsel erneut prüfen
  document.addEventListener('variant:change', pruneEmptyJudgeBlocks);})(); 














